/**
 * @generated SignedSource<<27635612390ff454734377a48d69b07f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SetCanRestartIfPassedContentConfigInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type RestartIfPassedContentConfigEditor_SetCanRestartIfPassedPassContentConfigMutation$variables = {
  input: SetCanRestartIfPassedContentConfigInput;
};
export type RestartIfPassedContentConfigEditor_SetCanRestartIfPassedPassContentConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly setCanRestartIfPassedContentConfig: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"RestartIfPassedContentConfigEditor_TreeNodeFragment">;
        };
      } | null;
    };
  };
};
export type RestartIfPassedContentConfigEditor_SetCanRestartIfPassedPassContentConfigMutation = {
  response: RestartIfPassedContentConfigEditor_SetCanRestartIfPassedPassContentConfigMutation$data;
  variables: RestartIfPassedContentConfigEditor_SetCanRestartIfPassedPassContentConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RestartIfPassedContentConfigEditor_SetCanRestartIfPassedPassContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetCanRestartIfPassedContentConfigPayload",
                "kind": "LinkedField",
                "name": "setCanRestartIfPassedContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RestartIfPassedContentConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestartIfPassedContentConfigEditor_SetCanRestartIfPassedPassContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetCanRestartIfPassedContentConfigPayload",
                "kind": "LinkedField",
                "name": "setCanRestartIfPassedContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "restartIfPassedConfig",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "147387cd3716fa64d27321002b089d1e",
    "id": null,
    "metadata": {},
    "name": "RestartIfPassedContentConfigEditor_SetCanRestartIfPassedPassContentConfigMutation",
    "operationKind": "mutation",
    "text": "mutation RestartIfPassedContentConfigEditor_SetCanRestartIfPassedPassContentConfigMutation(\n  $input: SetCanRestartIfPassedContentConfigInput!\n) {\n  Admin {\n    Tree {\n      setCanRestartIfPassedContentConfig(input: $input) {\n        contentNode {\n          ...RestartIfPassedContentConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment RestartIfPassedContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      restartIfPassedConfig {\n        __typename\n        configType\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0570a9cdf91fb13408a91e9d4c14feba";

export default node;
